import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { BLFactoryWeighDetailReport } from './Pages';

export const BLFactoryWeighDetailReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={BLFactoryWeighDetailReport} />
    </Fragment>
)